import videojs from 'video.js';
import { checkTouchScreen } from "../../js/helpers/checkTouchScreen";
const Component = videojs.getComponent('Component');
const ClickableComponent = videojs.getComponent('ClickableComponent');

const DEFAULTS = {
  default: 'defs' // id
};

/**
 * @typedef {Object} AudioTrack
 * @property {string} type - The type of the track
 * @property {string} url - The URL of the track
 * @property {string} title - The title of the track
 * @property {string} id - The unique identifier of the track
*/

/**
 * @typedef {Object} Options
 * @property {boolean} isAvailable
 * @property {Array<Number>} restrictedTrackIds
 * @property {Array<AudioTrack>} tracks
 */
class AudiotracksButton extends ClickableComponent {
  /**
   * @param {videojs.Player} player
   * @param {Options} options
  */
  constructor(player, options) {
    let options_ = Object.assign({}, DEFAULTS, options);
    super(player, options_);
    this.controlText(this.localize(options_.title ? options_.title : 'Audiotracks'));
    this.options = options_;

    this.setListeners_();
    this.updateVisibillity();
  }

  setListeners_() {
    if (this.options_.isMatchTVMode) {
      this.el().addEventListener(checkTouchScreen() ? 'touchstart' : 'click', (event) => {
        if (event.target.closest('.vjs-modal-dialog-content')) return;
        if (!this.options_.isAvailable) {
          this.options_.showRestrictionModalDialog(() => {
            this.options_.requestAccess({accessTo: 'feature'});
          });
          return;
        }
        let audiotracksSettings = this.getChild('audiotracksSettings');
        if (!audiotracksSettings) return;
        if (audiotracksSettings.hasClass('vjs-hidden')) {
          this.player().trigger('AudiotracksButton/click');
          const restrictionModalDialog = this.player().getChild('restrictionModalDialog');
          if (restrictionModalDialog) {
            restrictionModalDialog.hide(); 
          }
          this.showSettings();
        } else {
          this.hideSettings();
        }
      });
    }
    this.player().on('AudiotracksList/update', () => {
      this.updateVisibillity();
    });
  }

  updateVisibillity() {
    this.options_.audiotracksList.items.length > 1 ? this.show() : this.hide();
  }

  handleClick() {
    if (this.options_.isMatchTVMode) return;
    let player = this.player();
    let audiotracksSettings = player.getChild('audiotracksSettings');
    if (!audiotracksSettings) return;
    audiotracksSettings.hasClass('vjs-hidden') ? audiotracksSettings.show() : audiotracksSettings.hide();
  }

  showSettings() {
    const audiotracksSettings = this.getChild('audiotracksSettings');
    audiotracksSettings && audiotracksSettings.show();
    this.addClass('vjs-audiotracks-settings-show');
  }

  hideSettings() {
    const audiotracksSettings = this.getChild('audiotracksSettings');
    audiotracksSettings && audiotracksSettings.hide();
    this.removeClass('vjs-audiotracks-settings-show');
  }

  buildCSSClass() {
    return `vjs-audiotracks-control ${super.buildCSSClass()}`;
  }

  createEl() {
    return super.createEl('div', {
      className: this.buildCSSClass()
    });
  }
}

Component.registerComponent('AudiotracksButton', AudiotracksButton);
export default AudiotracksButton;
